// src/components/Header.js
import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";

const Header = () => {
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      variant="dark"
      className="navbar-custom"
      fixed="top"
    >
      <Container>
        <Navbar.Brand href="/">
          <img
            src="/assets/Logo-AmarantePET.jpg"
            alt="Amarante PetShop Logo"
            className="logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="#about" className="nav-link-custom">
              Sobre
            </Nav.Link>
            <Nav.Link href="#services" className="nav-link-custom">
              Serviços
            </Nav.Link>
            <Nav.Link href="#gallery" className="nav-link-custom">
              Clientes
            </Nav.Link>
            <Nav.Link href="#instagram" className="nav-link-custom">
              Instagram
            </Nav.Link>
            <Nav.Link href="#contact" className="nav-link-custom">
              Contato
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
